module.exports = __webpack_public_path__ + "static/img/image070.c792e48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image070.png
// module id = LHXi
// module chunks = 1